import { $t } from '@/i18n';
import wujiFetch from '@/utils/wujiFetch';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';
import reporter from '@/reporter/instance/designerReport';
import { addJsonPrefixIfOffline } from '@utils/offline';
import { zipPage, unzipPage } from '@/loaders/page/helper';

const fetchPage = async ({ projectId, pageId }) => {
  const page = await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}${addJsonPrefixIfOffline()}?projectid=${projectId}`);
  const unzip = await unzipPage(page);
  return unzip;
};

const updatePage = async ({ data, pageId, projectId }, headers = {}) => {
  try {
    // 页面编辑行为的统一上报
    reporter.report('click', {
      mod: $t('k_67fa32f'),
      eid: $t('k_b4a8e78b'),
    });
  } catch (e) {}

  const body = await zipPage(data);

  return await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}?projectid=${projectId}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body),
  });
};

const createPage = async ({ data, projectId }, headers = {}) => {
  const body = await zipPage(data);
  return await wujiFetch(`${getXyManagePathPrefix()}/page?projectid=${projectId}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
};

const deletePage = async ({ projectId, pageId }, headers = {}) => await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}?projectid=${projectId}`, {
  method: 'DELETE',
  headers,
});

export default {
  fetchPage,
  updatePage,
  createPage,
  deletePage,
};
